module.exports = __webpack_public_path__ + "static/media/not-found.3cec8468.png";